import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import { ProductDetailsAttribute } from '../types/productDetailsContent.types';

interface ProductDetailsAttributesProps {
  attributes?: ProductDetailsAttribute[];
}

const ProductDetailsAttributes = ({ attributes }: ProductDetailsAttributesProps) => {
  const { translate } = useTranslation();

  if (!attributes?.length) {
    return (
      <Typography variant="body1" color="text.secondary">
        {translate(LangEnum.GLOBAL_NO_INFORMATIONS)}
      </Typography>
    );
  }

  return (
    <Box
      component="ul"
      test-id="product-details-attributes"
      sx={{
        margin: 0,
        paddingLeft: 2.5,
        listStyleType: 'disc',
      }}
    >
      {attributes.map((attribute) => (
        <Typography key={attribute.id} component="li" variant="body1" color="text.secondary">
          {attribute.name}
        </Typography>
      ))}
    </Box>
  );
};

export default ProductDetailsAttributes;
